import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource } from '@angular/material';
import { SubjectMatter } from 'src/app/features/requets/shared/subject-matter.model';

@Component({
  selector: 'app-select-subjects-dialog',
  templateUrl: './select-subjects-dialog.component.html',
  styleUrls: ['./select-subjects-dialog.component.scss']
})
export class SelectSubjectsDialogComponent implements OnInit {

  displayedColumns = ['codMateria', 'nomMateria', 'codPrograma',  'version', 'calificacion'];
  selectedRowIndex = -1;
  SelectSubject: SubjectMatter;
  dataSource;


  tittle: String;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<SelectSubjectsDialogComponent>)  {
    this.dataSource = new MatTableDataSource<SubjectMatter>(data.subjectsMatter);
    this.dataSource.filterPredicate = (data1: SubjectMatter, filter: string) =>
    (data1.materia.nombre.indexOf(filter) !== -1 || data1.materia.codigo.toString().indexOf(filter) !== -1);

  }

  ngOnInit() {
  }

  applyFilter(filterValue: string) {


    this.dataSource.filter = filterValue.trim().toUpperCase();
  }

  close() {
    this.dialogRef.close(null);
  }

  highlight(row) {
    this.selectedRowIndex = row.materia.codigo;
    this.SelectSubject = row;
  }

  sendSelect() {
    const data = { index: this.data.index, subject: this.SelectSubject };
    this.dialogRef.close(data);
  }
}
